import React from 'react'
import { Wrap, Centered, FullCentered } from '@/styles/Layout'
import { Link } from 'gatsby'
import PostImage from './PostImage'
import PostLoopHeader from './PostLoopHeader'
import styled from 'styled-components'
import Plantel from '@/components/Featured/Mundial62/Plantel/Plantel'

const Article = styled.article``

const Post = ({
  post: {
    date,
    excerpt,
    featuredImage,
    formatFields: { posttitle, pretitle, largesttitle },
    metaFields: { author, authorsite, authorsiteurl },
    visualFields,
    postFormats,
    slug,
    title,
  },
}) => {
  const videoFormat = postFormats.nodes[0]?.name === 'Video'
  return (
    <Article className={videoFormat ? 'videoformat' : null}>
      {slug === 'los-22-que-marcaron-una-epoca' ? (
        <Plantel mode="home" />
      ) : (
        <PostLoopHeader
          title={title}
          pretitle={pretitle}
          posttitle={posttitle}
          largesttitle={largesttitle}
          author={author}
          authorsite={authorsite}
          authorsiteurl={authorsiteurl}
          date={date}
          slug={slug}
          videoFormat={videoFormat}
          featuredImage={featuredImage}
          excerpt={excerpt}
          visualFields={visualFields}
        />
      )}
    </Article>
  )
}

export default Post
